<p-card styleClass="card-grow h-full">
  <ng-template #title>
    <ng-container *ngTemplateOutlet="header()" />
  </ng-template>

  <ng-content />
</p-card>
